var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetCustomerApi, useGetPersonApi } from '../../hooks';
import { isFamilyMemberMinor, isFamilyMemberRegisterRequested, } from '../../redux';
import { useUpdateProfileHelper } from './helpers/useUpdateProfileHelper';
import { useFamilyMemberComposer } from './useFamilyMemberComposer.facade';
var onboardingDietTypeSelection = null;
export var useInputDietTypeFormFacade = function (_a) {
    var onNext = _a.onNext, personId = _a.personId, _b = _a.isFamilyMemberUpdate, isFamilyMemberUpdate = _b === void 0 ? false : _b, confirmAlert = _a.confirmAlert;
    //** REDUX **//
    var isNewFamilyMember = useSelector(isFamilyMemberRegisterRequested);
    var isFamilyMember = isNewFamilyMember || isFamilyMemberUpdate;
    var isMinor = useSelector(isFamilyMemberMinor);
    var _c = useState(null), selected = _c[0], setSelected = _c[1];
    var profile = useFamilyMemberComposer().profile;
    //** API **//
    var customer = useGetCustomerApi(!isFamilyMember).data;
    var person = useGetPersonApi(personId || (customer === null || customer === void 0 ? void 0 : customer.personId)).data;
    var updateProfile = useUpdateProfileHelper({
        isFamilyMember: isNewFamilyMember,
        person: person,
        customer: customer,
        confirmAlert: confirmAlert,
    }).updateProfile;
    // `personId` è valorizzato solo nei flussi di modifica di una persona esistente
    // (profilo proprio o scheda membro); nell'onboarding del leader è undefined.
    var isProfileEdit = !!personId;
    var labelsConjugationCondition = !isFamilyMember && (customer === null || customer === void 0 ? void 0 : customer.personId) === (person === null || person === void 0 ? void 0 : person.id);
    useEffect(function () {
        var defaultValue = isNewFamilyMember
            ? profile === null || profile === void 0 ? void 0 : profile.dietType
            : isProfileEdit
                ? person === null || person === void 0 ? void 0 : person.dietType
                : onboardingDietTypeSelection;
        if (defaultValue) {
            setSelected(defaultValue);
        }
    }, [isNewFamilyMember, isProfileEdit, profile === null || profile === void 0 ? void 0 : profile.dietType, person === null || person === void 0 ? void 0 : person.dietType]);
    var onUpdateDietType = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!selected) {
                return [2 /*return*/];
            }
            if (!isNewFamilyMember && !isProfileEdit) {
                onboardingDietTypeSelection = selected;
            }
            updateProfile({ dietType: selected }, onNext);
            return [2 /*return*/];
        });
    }); }, [isNewFamilyMember, isProfileEdit, selected, updateProfile, onNext]);
    return {
        selected: selected,
        setSelected: setSelected,
        onUpdateDietType: onUpdateDietType,
        confirmDisabled: !selected,
        isFamilyMember: isFamilyMember,
        isMinor: isMinor,
        labelsConjugationCondition: labelsConjugationCondition,
    };
};
